<template>
  <v-app id="inspire" class="bodyPadding"> 
    <mo-header></mo-header>
    <v-content>
		<transport-head></transport-head>		
		<transport-list></transport-list>
    </v-content>
  </v-app>
</template>

<script>

	import TransportHead from './Header.vue';	
	import TransportList from './List.vue';
	export default {
		data () {
			return {
		
			}		
		},
		components: {
          TransportHead,			
          TransportList
		}
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>